import { Alert, Button } from "@mui/material";
import { FC, useState } from "react";

interface Props {
	positions: string[];
	dates: string[];
}

const LIMIT = 10;

const RiskMissingPositionsAlert: FC<Props> = ({ positions, dates }) => {
	const [expanded, setExpanded] = useState(false);
	if (!positions.length) {
		return <></>;
	}
	const visible = expanded ? positions : positions.slice(0, LIMIT);
	const hidden = positions.length - visible.length;
	const names = hidden > 0 ? `${visible.join(', ')} e mais ${hidden}` : joinNames(visible);
	const plural = positions.length > 1;
	return (
		<Alert
			severity="warning"
			className="risk-missing-positions"
			action={positions.length > LIMIT
				? <Button color="inherit" size="small" onClick={() => setExpanded(!expanded)}>
					{expanded ? 'Ver menos' : 'Ver todos'}
				</Button>
				: undefined}
		>
			<strong>Atenção!</strong> A avaliação realizada {dateText(dates)} não contempla {plural ? 'os cargos' : 'o cargo'} {names},
			também {plural ? 'presentes' : 'presente'} na empresa.
		</Alert>
	);
};

function joinNames(names: string[]): string {
	if (names.length <= 1) {
		return names.join('');
	}
	return `${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}`;
}

function dateText(dates: string[]): string {
	if (!dates.length) {
		return 'nesta data';
	}
	return dates.length === 1 ? `em ${dates[0]}` : `nas datas ${joinNames(dates)}`;
}

export default RiskMissingPositionsAlert;
